export default "__VITE_ASSET__CL0WuHDE__"